<template>
  <div style="display: inline-block">
    <vs-button v-on:click="popupActive = true" style="height: 40px; border-radius: 3px" color="primary"
      type="gradient">Ürünleri Çek</vs-button>
    <vs-popup title="Ürünleri Çek" :active.sync="popupActive">
      <div id="loading-urunCek" class="vs-con-loading__container" style="min-height: 220px">
        <b-row>
          <b-col>
            <v-select v-model="selectedMarketplace" placeholder="Pazaryeri Seçiniz" label="name"
              :options="marketplaces" append-to-body />
          </b-col>
        </b-row>
        <vs-divider />
        <b-row align-h="end">
          <b-col cols="12" md="auto">
            <vs-button v-on:click="urunleriCek()" style="height: 40px; border-radius: 3px" color="primary" icon="done"
              type="gradient">Ürünleri Çek</vs-button>
          </b-col>
        </b-row>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import state from "../../../../store/state";
import Store from "../../../../store/store";
import vSelect from "vue-select";
export default {
  components: {
    vSelect
  },
  data() {
    return {
      popupActive: false,
      selectedMarketplace: "",
      marketplaces: [],
      // 3 saat = 3 * 60 * 60 * 1000 ms
      limitSuresi: 3 * 60 * 60 * 1000,
      // localStorage anahtarı (kullanıcı bazında ayrılır)
      storageKey: "urunCekSonIstek_" + Store.state.tokenId
    };
  },
  watch: {
    popupActive(val) {
      if (val) {
        this.selectedMarketplace = "";
      }
    }
  },
  methods: {
    // localStorage'daki { pazaryeriAdi: sonIstekZamani(ms) } haritasını okur
    sonIstekleriGetir() {
      try {
        return JSON.parse(localStorage.getItem(this.storageKey)) || {};
      } catch (error) {
        return {};
      }
    },
    // Bir pazaryeri için son istek zamanını kaydeder
    sonIstekKaydet(pazaryeri) {
      let kayitlar = this.sonIstekleriGetir();
      kayitlar[pazaryeri] = Date.now();
      localStorage.setItem(this.storageKey, JSON.stringify(kayitlar));
    },
    // Süreyi "2 saat 15 dakika" gibi okunur metne çevirir
    sureMetni(ms) {
      let toplamDakika = Math.ceil(ms / 60000);
      let saat = Math.floor(toplamDakika / 60);
      let dakika = toplamDakika % 60;
      if (saat > 0) return saat + " saat " + dakika + " dakika";
      return dakika + " dakika";
    },
    urunleriCek() {
      var vm = this;
      var vs = this.$vs;
      let type = "radius";
      if (!vm.selectedMarketplace || !vm.selectedMarketplace.name) {
        vs.notify({
          text: "Pazaryeri seçimi yapmadınız.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
        return;
      }
      // Aynı pazaryeri için 3 saatte bir istek atılabilir
      let pazaryeri = vm.selectedMarketplace.name;
      let sonIstek = vm.sonIstekleriGetir()[pazaryeri];
      if (sonIstek) {
        let gecenSure = Date.now() - sonIstek;
        if (gecenSure < vm.limitSuresi) {
          vs.notify({
            title: "Ürünleri Çek",
            text:
              pazaryeri +
              " için tekrar istek atabilmek için " +
              vm.sureMetni(vm.limitSuresi - gecenSure) +
              " beklemelisiniz.",
            iconPack: "feather",
            icon: "icon-clock",
            color: "warning",
            position: "top-center"
          });
          return;
        }
      }
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        pazaryeri: vm.selectedMarketplace.name
      };
      vs.loading({
        container: "#loading-urunCek",
        type
      });
      soap.createClient(url, function (err, client) {
        client.urunleriCek(args, function (err, result) {
          if (result.urunleriCekResult == "-1") {
            Store.dispatch("logout");
          }
          try {
            vs.loading.close("#loading-urunCek > .con-vs-loading");
            vm.veriler = JSON.parse(result.urunleriCekResult);
            vm.sonIstekKaydet(pazaryeri);
            vm.popupActive = false;
            vs.notify({
              title: "Ürünleri Çek",
              text: "İşleminiz listeye alınmıştır.",
              iconPack: "feather",
              icon: "icon-check-circle",
              color: "success",
              position: "top-center"
            });
          } catch (error) {
            vs.loading.close("#loading-urunCek > .con-vs-loading");
            vs.notify({
              title: "Ürünleri Çek",
              text: "Ürünler çekilemedi",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }
        });
      });
    }
  },
  created() {
    try {
      let moduller = JSON.parse(Store.state.moduller);
      if (Array.isArray(moduller)) {
        moduller.forEach((val) => {
          this.marketplaces.push({ name: val.marketplace });
        });
      }
    } catch (error) {
      console.log("Pazaryeri modülleri yüklenemedi:", error);
    }
  }
};
</script>
<style>
.vs__dropdown-menu {
  z-index: 999999 !important;
}
</style>
